import {Injectable} from "@angular/core";
import {Store} from "@ngrx/store";
import {ICreateSavedFilterRequestDTO} from "../save-filters.dto";

import * as SavedFiltersActions from  './saved-filters.actions'

@Injectable({
    providedIn:'root'
})
export class SaveListingFilters {

    constructor(private _store:Store) {
    }

    fetchSavedFilters():void{
        return this._store.dispatch(SavedFiltersActions.fetchSavedFilters());
    }

    saveFilter(filter: ICreateSavedFilterRequestDTO) {
        return this._store.dispatch(SavedFiltersActions.saveFilters({filter}));
    }
}